import type { Endpoint } from '../../features/catalog/model';
import {
  exampleFields,
  exampleObject,
  requestFields,
  responseFields,
  type FieldRow,
} from '../../lib/endpointFields';
import { requirableFields } from '../../lib/requireFields';
import { schemaExample } from '../../lib/schemaForm';

export interface ReferenceRows {
  /** the fields you send, valued from the example request */
  request: FieldRow[];
  /** the fields you get back */
  response: FieldRow[];
  /** response fields a caller may mark required */
  requirable: Set<string>;
}

/**
 * The one computation behind both statements of an endpoint's contract, the
 * public page's band and the dashboard section, so they state the same request
 * and the same response.
 *
 * Both lists are the schema's fields, valued from the authored examples where
 * they share a path, so a short example never hides the rest of the contract.
 */
export const referenceRows = (
  endpoint: Endpoint,
  inputSchema: unknown,
  outputSchema: unknown,
): ReferenceRows => {
  const input = exampleObject(endpoint.inputExample) ?? schemaExample(inputSchema);
  return {
    request: inputSchema ? requestFields(inputSchema, input) : exampleFields(endpoint.inputExample),
    response: responseFields(outputSchema, exampleFields(endpoint.sampleResponse)),
    requirable: requirableFields(inputSchema),
  };
};
